import { Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

import iconImage from "../../assets/piggy/icon.png";
import { PIGGY_UPDATED } from "./constants";
import usePageMeta from "./usePageMeta";
import "./Legal.scss";

/**
 * Shared frame for Piggy's legal pages. `sections` is an array of
 * { id, title, body } where body is JSX.
 */
const LegalPage = ({ kind, title, intro, sections, description }) => {
  usePageMeta(`${title} · Piggy`, description);

  return (
    <div className="piggy-legal">
      <header className="piggy-legal__header">
        <div className="piggy-legal__bar">
          <Link to="/piggy" className="piggy-legal__back">
            <FiArrowLeft aria-hidden="true" />
            <span>Piggy</span>
          </Link>
          <nav className="piggy-legal__switch" aria-label="Legal documents">
            <Link
              to="/piggy/privacy"
              className={kind === "privacy" ? "is-active" : undefined}
              aria-current={kind === "privacy" ? "page" : undefined}
            >
              Privacy
            </Link>
            <Link
              to="/piggy/terms"
              className={kind === "terms" ? "is-active" : undefined}
              aria-current={kind === "terms" ? "page" : undefined}
            >
              Terms
            </Link>
          </nav>
        </div>

        <div className="piggy-legal__title">
          <img src={iconImage} width={44} height={44} alt="" />
          <div>
            <p className="piggy-legal__eyebrow">Piggy · {title}</p>
            <h1>{title}</h1>
            <p className="piggy-legal__updated">Last updated {PIGGY_UPDATED}</p>
          </div>
        </div>
        {intro ? <div className="piggy-legal__intro">{intro}</div> : null}
      </header>

      <div className="piggy-legal__body">
        <nav className="piggy-legal__toc" aria-label="On this page">
          <p>On this page</p>
          <ol>
            {sections.map((section) => (
              <li key={section.id}>
                <a href={`#${section.id}`}>{section.title}</a>
              </li>
            ))}
          </ol>
        </nav>

        <main id="piggy-main" className="piggy-legal__content">
          {sections.map((section, index) => (
            <section key={section.id} id={section.id} aria-labelledby={`${section.id}-h`}>
              <h2 id={`${section.id}-h`}>
                <span className="piggy-legal__num">{String(index + 1).padStart(2, "0")}</span>
                {section.title}
              </h2>
              {section.body}
            </section>
          ))}
        </main>
      </div>

      <footer className="piggy-legal__footer">
        <Link to="/piggy">Piggy</Link>
        <span aria-hidden="true">·</span>
        <Link to="/piggy/privacy">Privacy policy</Link>
        <span aria-hidden="true">·</span>
        <Link to="/piggy/terms">Terms of service</Link>
      </footer>
    </div>
  );
};

export default LegalPage;
